
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalNorth as ObiBuoyConicalNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-north.js';
 
 
 

 
 export const ObiBuoyConicalNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-north',
   elementClass: ObiBuoyConicalNorthElement,
   events: {
     
   }
  });
 
 